export const TWITTER_PIXEL_ID = process.env.NEXT_PUBLIC_TWITTER_PIXEL_ID;

declare global {
  interface Window {
    twq: any;
  }
}
